import type {
  ChangeCompleteStatusData,
  CreateHomeworksData,
  DeleteHomeworksData,
  StudentHomeworkChangeRequest,
  StudentHomeworkCreateRequest,
} from '~/api-spec/__generated__/main'
import { httpClient, type RequestMeta } from '~/http/client'
import type { WithNullableOptionals } from '~/http/request'

import type { Homework } from './schemas'

// 2026-10-14 백엔드 develop(6a0f8e7bb) 의 studentHomework/controller/StudentHomeworkController.kt·request/ 로 확인.
// 모두 응답 본문을 쓰지 않는다.

// type 이 WORKBOOK 이면 bookIdList 가 교재 ID 이고 round(회차)·pageList(페이지 번호)를 함께 보낸다. WORKSHEET·CAS 는
// 학습지·자동시험 ID 만 보낸다. round·pageList 는 서버가 nullable 로 받는다.
export type HomeworkAssignBody = WithNullableOptionals<StudentHomeworkCreateRequest>

/** 학생들에게 숙제를 낸다 */
export const assignHomeworks = async (
  body: HomeworkAssignBody,
  meta?: RequestMeta,
): Promise<void> => {
  await httpClient().post<CreateHomeworksData>('/student-homework', body, { meta })
}

export type HomeworkCompletionBody = StudentHomeworkChangeRequest

/** 숙제를 완료·미완료로 바꾼다 */
export const updateHomeworkCompletion = async (
  body: HomeworkCompletionBody,
  meta?: RequestMeta,
): Promise<void> => {
  await httpClient().patch<ChangeCompleteStatusData>('/student-homework', body, { meta })
}

export const deleteHomeworks = async (
  homeworkIds: Homework['id'][],
  meta?: RequestMeta,
): Promise<void> => {
  await httpClient().delete<DeleteHomeworksData>('/student-homework', { data: homeworkIds, meta })
}
